const urlTenantKey = window.location.pathname.split('/')[1]
export const isDevelopment =
  process.env.NODE_ENV === 'development' ||
  window.location.origin.split('campx')[1] === '.dev'

export const isSetup = window.location.hostname.split('.').includes('setup')
